<template>
  <v-card class="elevation-0 form-dados" max-height="60vh">
    <v-card-text>
      <v-progress-linear v-if="loading" indeterminate color="yellow darken-2"></v-progress-linear>
      <div v-else>
        <v-expand-transition>
          <div class="d-flex flex-column">
            <b class="mb-5">Confirme seus dados de atendimento</b>
            <v-form ref="form">
              <v-row v-if="user">
                <v-col cols="12" class="my-0 py-0">
                  Seu nome
                  <v-text-field v-model="user.nome" type="text" solo flat dense placeholder="Digite aqui seu nome"
                    class="custom-textfield mt-1" :rules="[
                      () => $v.user.nome.required || 'Campo obrigatório',
                      () => $v.user.nome.minLength || 'Mínimo de 6 caracteres'
                    ]" />
                </v-col>
                <v-col cols="12" class="my-0 py-0">
                  Seu email
                  <v-text-field v-model="user.email" type="email" solo flat dense placeholder="Digite aqui seu e-mail"
                    class="custom-textfield mt-1" :rules="[
                      () => $v.user.email.required || 'Campo obrigatório',
                      () => $v.user.email.email || 'E-mail inválido'
                    ]" />
                </v-col>
                <v-col cols="12" class="my-0 py-0">
                  Seu CPF
                  <v-text-field v-model="user.cpf" type="text" solo flat dense v-mask="'###.###.###-##'"
                    placeholder="Digite aqui seu CPF" class="custom-textfield mt-1" :rules="[
                      () => $v.user.cpf.required || 'Campo obrigatório',
                      () => $v.user.cpf.minLength || 'CPF inválido',
                      v => validaCpf(v) || 'CPF inválido'
                    ]" />
                </v-col>
                <v-col cols="12" class="my-0 py-0">
                  Sua data de nascimento
                  <v-text-field solo flat placeholder="Digite sua data de nascimento" v-model="user.dtNascimento"
                    class="custom-textfield mt-1" v-mask="'##/##/####'" :rules="[
                      () => $v.user.dtNascimento.required || 'Campo obrigatório',
                      () => $v.user.dtNascimento.minimal || 'O funcionário tem que ter pelo menos 14 anos'
                    ]" />
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-expand-transition>
      </div>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text @click="$emit('close')">
        Cancelar
      </v-btn>
      <v-btn color="primary" @click="updateUserData" :loading="loadingUpdate" :disabled="loadingUpdate">
        Continuar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import userService from '@/services/user'
import { required, minLength, email, maxLength } from 'vuelidate/lib/validators'
import validaCpf from '@/utils/validaCpf'
import { validationMixin } from 'vuelidate'
import { dateRegex } from '@/utils/constants'
import { formatDate, extractOnlyNumbers } from '@/utils/formatter'
import minimalDate from '../../utils/minimalDate'
import { parse } from 'date-fns'

export default {
  mixins: [validationMixin],
  validations: {
    user: {
      nome: {
        required,
        minLength: minLength(6)
      },
      cpf: {
        required,
        minLength: minLength(14)
      },
      email: {
        required,
        email
      },
      dtNascimento: {
        required,
        validDate(dtNascimento) {
          if (dtNascimento) {
            const [day, month, year] = dtNascimento.split('/')
            return dateRegex.test(dtNascimento) && new Date(year, month - 1, day) < new Date(Date.now())
          }
          return false
        },
        minimal(dt_nascimento) {
          const dataNascimento = parse(dt_nascimento, 'dd/MM/yyyy', new Date())
          return minimalDate(dataNascimento, 14)
        }
      },
      funcionario: {
        ctps: { maxLength: maxLength(20) },
        serie_ctps: { maxLength: maxLength(10) },
        pis_pasep: { minLength: minLength(14) }
      }
    }
  },
  data() {
    return {
      stepper: 1,
      picker: null,
      user: null,
      loading: false,
      loadingUpdate: false
    }
  },
  methods: {
    disablePastDates(val) {
      return val >= new Date().toISOString().substr(0, 10)
    },
    validaCpf(cpf) {
      if (process.env.VUE_APP_ENV === 'DEV') return true
      return validaCpf(cpf)
    },
    async getUserData() {
      try {
        this.loading = true
        const { data } = await userService.showDadosBasicos()
        this.user = { ...data, dtNascimento: new Date(data.dtNascimento).toLocaleDateString('pt-br') }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async updateUserData() {
      if (this.$refs.form.validate()) {
        try {
          this.loadingUpdate = true
          const params = {
            ...this.user,
            dtNascimento: formatDate(this.user.dtNascimento),
            cpf: extractOnlyNumbers(this.user.cpf)
          }
          await userService.updateDadosBasicos(params)
          this.$showSuccessMessage('Dados confirmados')
          this.$emit('update-step', 2)
        } catch ({ response }) {
          this.$showErrorMessage(response.data.message)
        } finally {
          this.loadingUpdate = false
        }
      }
    }
  },
  mounted() {
    this.getUserData()
  }
}

</script>